
import React from "react";
import Logo from "../../assets/Member/Naayalogo.png";
import background from "../../assets/Member/background.png";
import laptop from "../../assets/Member/laptop.png";
import flag from "../../assets/Member/flag.png";
import naaya from "../../assets/Member/naaya.png";
import loan from "../../assets/Member/loan.png";
import iphone from "../../assets/Member/iphone.png";
import img1 from "../../assets/Member/img1.png";
import img2 from "../../assets/Member/img2.png";
import img3 from "../../assets/Member/img3.png";
import img4 from "../../assets/Member/img4.png";
import img5 from "../../assets/Member/img5.png";
import img6 from "../../assets/Member/img6.png";

import Navbar from "../Home/navbar/Navbar";
import Footer from "../Home/Footer/Footer";

const CurvedArrow = () => (
  <svg width="100" height="180" viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 40 C20 20, 80 20, 90 40" // Starts higher and curves down
      stroke="black"
      strokeWidth="2"
      strokeDasharray="5,5"
      fill="none"
    />
    <polygon
      points="95,35 95,40 85,45" // Arrowhead
      fill="black"
    />
  </svg>
);

const Item = ({ imageSrc, text }) => {
  return (
    <div className="flex flex-col items-center">
      <img src={imageSrc} alt="" className="w-[100px] h-[100px]" />
      <p className="w-[121px] h-[56px] font-semibold text-[14px] mt-3 text-center">{text}</p>
    </div>
  );
};

const items = [
  { imageSrc: img1, text: "Become a buyer on Naayatrade" },
  { imageSrc: img6, text: "Find products and sellers" },
  { imageSrc: img5, text: "Connect with sellers" },
  { imageSrc: img4, text: "Place and protect order" },
  { imageSrc: img3, text: "Pay on Naayatrade.com" },
  { imageSrc: img2, text: "Ship and receive your goods" },
];

const Member = () => {
  return (
    <div>
      <Navbar />
      <div className="w-full h-[1240px]">
        {/* First section with background image */}
        <div
          className="w-full h-[485px] bg-cover bg-center bg-white"
          style={{ backgroundImage: `url(${background})` }}
        >
          <div className="w-[1240px] h-[545px] m-auto flex items-center gap-40">
            <div>
              <img src={Logo} alt="" className="w-[103px] h-[103px]" />
              <p className="w-[215px] h-[35px] text-[#FF6300] font-medium text-[20px] mt-2">
                NAAYATRADE
              </p>
              <p className="w-[197px] h-[19px] font-normal text-[14px]">
                New era of
                <span className="font-semibold bg-[#FFF7CB] ml-1">
                  Doing Business.
                </span>
                
              </p>
            </div>

            <div className="relative w-[456px] h-[456px]">
              <img src={laptop} alt="" className="w-[345px] h-[345px] mt-10 mx-auto" />

              <div className="absolute left-[-140px] top-[65%] transform translate-y-[-50%] flex w-[265px] h-[60px] mt-10 bg-[#E9F0FF] gap-3 items-center rounded-lg">
                <p className="w-[198px] h-[21px] text-[14px] font-semibold ml-2">
                  Find new Seller across India
                </p>
                <img src={flag} alt="" />
              </div>

              <div className="absolute right-[-70px] top-[20%] transform translate-y-[-70%] flex w-[245px] h-[60px] bg-[#FFF7CB] gap-1 items-center rounded-lg">
                <img src={naaya} alt="" className="w-[30px] h-[30px] ml-3" />
                <p className="w-[190px] h-[21px] text-[14px] font-semibold ml-2">
                  Join Naayatrade.com
                </p>
              </div>

              <div className="absolute right-[-150px] top-[65%] transform translate-y-[-50%] flex w-[265px] h-[60px] bg-[#DDFFCD] gap-1 items-center rounded-lg">
                <img src={loan} alt="" className="w-[30px] h-[30px] ml-3" />
                <p className="w-[208px] h-[24px] text-[14px] font-semibold ml-2">
                  Buy everything at 0%* commission
                </p>
              </div>
            </div>

                <div className=" w-[300px] h-[100px] ml-20 ">
              <p className="text-[16px] font-semibold pb-2">Start buying</p>
              <ul className="list-disc list-item ml-5">
                <li className="text-[14px] font-normal">1 storefront</li>
              </ul>
              <ul className="list-disc list-item ml-5">
                <li className="text-[14px] font-normal">
                  Thousands of active B2B sellers
                </li>
              </ul>
              <ul className="list-disc list-item ml-5">
                <li className="text-[14px] font-normal">0% commission</li>
              </ul>
              <ul className="list-disc list-item ml-5">
                <li className="text-[14px] font-normal text-[#FF6300]">
                  {" "}
                  And much more…
                </li>
              </ul>
              <button className="w-[135px] h-[46px] bg-[#FF6300] text-white rounded-3xl mt-3">
                Start buy
              </button>
            </div>
          </div>
        </div>

        {/* Second section */}
        <div className="w-[1240px] h-[300px] m-auto flex gap-40">
          <div>
            <p className="w-[412px] h-[36px] text-[#FF6300] text-[30px] font-semibold mt-4">
              What is NAAYATRADE .COM
            </p>
            <p className="w-[604px] h-[180px] mt-4 font-medium text-[20px]">
              Naayatrade is a B2B e-commerce marketplace that helps SMEs buy and
              sell their goods worldwide. Founded in 2022 with the vision to
              "transform the way trade happens in India through innovative
              technology," Naayatrade has swiftly become India's go-to B2B
              platform.
            </p>
          </div>
          <div>
            <img src={iphone} alt="" />
          </div>
        </div>

        {/* Third section */}
        <div className="w-[1240px] h-[300px] m-auto">
          <div>
            <p className="w-[575px] h-[36px] text-[#FF6300] text-[30px] font-semibold">
              New to sourcing on Naayatrade.com?
            </p>
            <p className="w-[1200px] h-[72px] font-medium text-[20px] mt-4">
              Find everything you need in one place. From finding ready-to-ship
              products or a partner to customize the product you want, all the
              way through to ensuring quality and shipping your order to its
              final destination.
            </p>
          </div>

          <div className="w-[1240px] m-auto mt-10 flex items-center justify-between">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                <Item imageSrc={item.imageSrc} text={item.text} />
                {index < items.length - 1 && <CurvedArrow />}
              </React.Fragment>
            ))}
          </div>
          <div className="w-[1240px] m-auto ">
            <p className="w-[338px] h-[36px] text-[#FF6300] font-semibold text-[30px]">
              Order with confidence
            </p>
            <p className="w-[1218px] h-[36px] font-medium text-[20px] mt-3">
              Ensure product quality and on-time delivery with Trade Assurance,
              the Naayatrade.com order protection service.
            </p>
          </div>
        </div>
      </div>
        <Footer />
    </div>
  );
};

export default Member;
